// eslint-disable-next-line import/prefer-default-export
export const recaptchaKey = '6LdBr08dAAAAAM7X0EFpv2g2MOKpybY9jwylTnJR';
